import { render } from "./PasswordRecovery.vue?vue&type=template&id=5cdeaecd&scoped=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=5cdeaecd&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdeaecd"]])

export default __exports__